// Replace with your Firebase config
export const firebaseConfig = {
  apiKey: "AIzaSyBpPp5RjqG_caHhju4H22cyK36tLKqSPlA",
  authDomain: "greg-oshea.firebaseapp.com",
  databaseURL: "https://greg-oshea-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "greg-oshea",
  storageBucket: "greg-oshea.appspot.com",
  messagingSenderId: "118096411811",
  appId: "1:118096411811:web:b877598791c937e0541316",
  measurementId: "G-3XXBX6W7ZS"
};


  export const firebaseConfigSandbox = {
    apiKey: "AIzaSyDR5YsfF0e40Ul27sCVDSW4mYx425jXOsM",
    authDomain: "greg-sandbox-fcb39.firebaseapp.com",
    databaseURL: "https://greg-sandbox-fcb39-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "greg-sandbox-fcb39",
    storageBucket: "greg-sandbox-fcb39.appspot.com",
    messagingSenderId: "29979463181",
    appId: "1:29979463181:web:f6f10204d00f918a700f44",
    measurementId: "G-3QJNQ2YZS5"
  };
  
